"use strict";
/* eslint-disable max-lines */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prebuiltEmployeeSatisfaction = void 0;
const templateUtils_1 = require("../../templateUtils");
const triggerFormContent = {
    subject: 'Employee Satisfaction Survey',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: 'ffd029a6-b6b8-431a-98ba-f4462a9022b7',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/employee_satisfaction_survey.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: 'd35dec1e-0ed6-48f1-b8c5-c138bb46e2dd',
            data: {
                backgroundColor: '#ffffff',
                label: 'Name',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'text',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: '0119417b-a8d6-4e09-be15-c36c838cf484',
            data: {
                backgroundColor: '#ffffff',
                label: 'Email Address',
                requiredField: true,
                helperText: 'We&#x27;ll provide you with a copy of your response for your own records via email.',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'email',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: 'c0112203-d3a1-4948-854e-9f4539974377',
            data: {
                backgroundColor: '#ffffff',
                label: 'Department',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'text',
            },
        },
        {
            type: 'display-divider',
            version: '1',
            id: '54e84fa0-68ea-4c64-85db-489adaccbafd',
            data: {
                borderStyle: 'solid',
                borderWidth: 3,
                dividerWidth: 100,
                dividerAlign: 'center',
                dividerColor: '#E0E0E0',
                backgroundColor: '#FFFFFF',
                paddingTop: 40,
                paddingBottom: 40,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: 'fa221c95-7115-42c3-8e25-e955de6ec269',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '1. How meaningful is your work? ',
                options: [
                    {
                        label: 'Extremely meaningful',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'Very meaningful',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'Moderately meaningful',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'Slightly meaningful',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Not at all meaningful',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '21cc0794-caac-497a-a978-9c2f5e2cca7a',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '2. How challenging is your job?',
                options: [
                    {
                        label: 'Extremely challenging',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'Very challenging',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'Moderately challenging',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'Slightly challenging',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Not at all challenging',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '060784a6-eb65-4190-b0e2-ddbc1c3ed3e5',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '3. In a typical week, how often do you feel stressed at work? ',
                options: [
                    {
                        label: 'Extremely often',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'Very often',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'Moderately often',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'Slightly often',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Not at all often',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '4bb936d9-1c2e-4d33-94eb-9398fb302bc5',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '4. How well are you paid for the work you do?',
                options: [
                    {
                        label: 'Extremely well',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'Very well',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'Moderately well',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'Slightly well',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Not at all well',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: 'deec6969-f452-4835-ad3d-3b1870c2e40a',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '5. How much do your opinions about work matter to your coworkers?',
                options: [
                    {
                        label: 'A great deal',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'A lot',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'A moderate amount',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'A little',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Not at all',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '8320d454-3c77-4a83-9443-6cae6b6202ef',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '6. How realistic are the expectations of your supervisor? ',
                options: [
                    {
                        label: 'Extremely realistic',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'Very realistic',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'Moderately realistic',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'Slightly realistic',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Not at all realistic',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: 'c4940135-03c0-42ea-8c2f-fbf77b0bc734',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '7. How often do the tasks assigned to you by your supervisor help you grow professionally? ',
                options: [
                    {
                        label: 'Extremely often',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'Very often',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'Moderately often',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'Slightly often',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Not at all often',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: 'd820261e-5097-4222-bb22-af1e6f216a1e',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '8. How many opportunities do you have to get promoted where you work?',
                options: [
                    {
                        label: 'A great deal',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'A lot',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'A moderate amount',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'A little',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Not at all',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '8b30eced-1ff1-43f1-b6b4-5edaa76da25e',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '9. Are you supervised too much at work, supervised too little or supervised about the right amount?',
                options: [
                    {
                        label: 'Much too much',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'Somewhat too much',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'Slightly too much',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'About the right amount',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Slightly too little',
                        value: false,
                    },
                    {
                        id: 'dfd9be2c-c8b8-4472-9eb3-c5935466dca6',
                        label: 'Somewhat too little',
                        value: false,
                    },
                    {
                        id: '892fc40e-f1cb-4bb6-b557-9fbd7ce82df3',
                        label: 'Much too little',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '850cd12a-8bec-4c5b-ac2c-bd4b0f11a37c',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '10. Are you satisfied with your employee benefits, neither satisfied nor dissatisfied with them, or dissatisfied with them? ',
                options: [
                    {
                        label: 'Extremely satisfied',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'Moderately satisfied',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'Slightly satisfied',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'Neither nor satisfied dissatisfied',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Slightly dissatisfied',
                        value: false,
                    },
                    {
                        id: 'dfd9be2c-c8b8-4472-9eb3-c5935466dca6',
                        label: 'Moderately dissatisfied',
                        value: false,
                    },
                    {
                        id: '6c8ebf19-278f-4fc0-acb6-e3aada779c26',
                        label: 'Extremely dissatisfied',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '39a7cf9a-eaf6-495a-897f-ba4f63c1c916',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '11. Are  you satisfied with your job, neither satisfied nor dissatisfied with it, or dissatisfied with it? ',
                options: [
                    {
                        label: 'Extremely satisfied',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'Moderately satisfied',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'Slightly satisfied',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'Neither nor satisfied dissatisfied',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Slightly dissatisfied',
                        value: false,
                    },
                    {
                        id: 'dfd9be2c-c8b8-4472-9eb3-c5935466dca6',
                        label: 'Moderately dissatisfied',
                        value: false,
                    },
                    {
                        id: '6c8ebf19-278f-4fc0-acb6-e3aada779c26',
                        label: 'Extremely dissatisfied',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '72f5bfa5-a5a7-4d28-8f23-bedb0e987357',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '12. How proud are you of your employer’s brand?',
                options: [
                    {
                        label: 'Extremely proud',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'Very proud',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'Moderately proud',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'Slightly proud',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Not at all proud',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '63160549-3feb-4d2a-9ab8-0d21cb7cd5bd',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '13. Do you like your employer, neither like or dislike them, or dislike them?',
                options: [
                    {
                        label: 'A great deal',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'A lot',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'A moderate amount',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'A little',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Not at all',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '850c231f-a839-460e-9347-b54e0cfe7217',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '14. How likely are you to look for a job outside the company? ',
                options: [
                    {
                        label: 'Extremely likely',
                        id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                        value: false,
                    },
                    {
                        label: 'Very likely',
                        id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                        value: false,
                    },
                    {
                        label: 'Moderately likely',
                        id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                        value: false,
                    },
                    {
                        id: '6bccd029-2957-423d-afde-976e84fe000b',
                        label: 'Slightly likely',
                        value: false,
                    },
                    {
                        id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                        label: 'Not at all likely',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-submit-button',
            version: '1',
            id: 'af090838-f01c-4765-9065-3b0aa441d5ae',
            data: {
                backgroundColor: '#FFFFFF',
                borderColor: '#5700D4',
                borderRadius: 4,
                buttonColor: '#6200EE',
                color: '#FFFFFF',
                fontSize: 14,
                paddingBottom: 10,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 10,
                text: 'Submit',
                textAlign: 'center',
                width: 600,
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: '09f0ec6b-ea8f-4f83-be80-e268835ee698',
            data: {
                text: '<p>Powered by <strong>Whispir</strong></p>',
                position: 'middle-middle',
                color: '#9E9E9E',
                textPadding: 0,
                src: 'https://cdn-au.whispir.com/public/resources/313a588f0b0ae6c3caa57f6536a540ab50.jpe',
                backgroundColor: '#F3F3F3',
                height: 60,
                fullWidth: false,
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
    ],
    inputVariables: [],
    outputVariables: [
        {
            id: 'd35dec1e-0ed6-48f1-b8c5-c138bb46e2dd',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Name',
        },
        {
            id: '0119417b-a8d6-4e09-be15-c36c838cf484',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Email Address',
        },
        {
            id: 'c0112203-d3a1-4948-854e-9f4539974377',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Department',
        },
        {
            id: 'fa221c95-7115-42c3-8e25-e955de6ec269',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '1. How meaningful is your work? ',
            options: [
                {
                    label: 'Extremely meaningful',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'Very meaningful',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'Moderately meaningful',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'Slightly meaningful',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Not at all meaningful',
                    value: false,
                },
            ],
        },
        {
            id: '21cc0794-caac-497a-a978-9c2f5e2cca7a',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '2. How challenging is your job?',
            options: [
                {
                    label: 'Extremely challenging',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'Very challenging',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'Moderately challenging',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'Slightly challenging',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Not at all challenging',
                    value: false,
                },
            ],
        },
        {
            id: '060784a6-eb65-4190-b0e2-ddbc1c3ed3e5',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '3. In a typical week, how often do you feel stressed at work? ',
            options: [
                {
                    label: 'Extremely often',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'Very often',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'Moderately often',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'Slightly often',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Not at all often',
                    value: false,
                },
            ],
        },
        {
            id: '4bb936d9-1c2e-4d33-94eb-9398fb302bc5',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '4. How well are you paid for the work you do?',
            options: [
                {
                    label: 'Extremely well',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'Very well',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'Moderately well',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'Slightly well',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Not at all well',
                    value: false,
                },
            ],
        },
        {
            id: 'deec6969-f452-4835-ad3d-3b1870c2e40a',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '5. How much do your opinions about work matter to your coworkers?',
            options: [
                {
                    label: 'A great deal',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'A lot',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'A moderate amount',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'A little',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Not at all',
                    value: false,
                },
            ],
        },
        {
            id: '8320d454-3c77-4a83-9443-6cae6b6202ef',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '6. How realistic are the expectations of your supervisor? ',
            options: [
                {
                    label: 'Extremely realistic',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'Very realistic',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'Moderately realistic',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'Slightly realistic',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Not at all realistic',
                    value: false,
                },
            ],
        },
        {
            id: 'c4940135-03c0-42ea-8c2f-fbf77b0bc734',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '7. How often do the tasks assigned to you by your supervisor help you grow professionally? ',
            options: [
                {
                    label: 'Extremely often',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'Very often',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'Moderately often',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'Slightly often',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Not at all often',
                    value: false,
                },
            ],
        },
        {
            id: 'd820261e-5097-4222-bb22-af1e6f216a1e',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '8. How many opportunities do you have to get promoted where you work?',
            options: [
                {
                    label: 'A great deal',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'A lot',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'A moderate amount',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'A little',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Not at all',
                    value: false,
                },
            ],
        },
        {
            id: '8b30eced-1ff1-43f1-b6b4-5edaa76da25e',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '9. Are you supervised too much at work, supervised too little or supervised about the right amount?',
            options: [
                {
                    label: 'Much too much',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'Somewhat too much',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'Slightly too much',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'About the right amount',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Slightly too little',
                    value: false,
                },
                {
                    id: 'dfd9be2c-c8b8-4472-9eb3-c5935466dca6',
                    label: 'Somewhat too little',
                    value: false,
                },
                {
                    id: '892fc40e-f1cb-4bb6-b557-9fbd7ce82df3',
                    label: 'Much too little',
                    value: false,
                },
            ],
        },
        {
            id: '850cd12a-8bec-4c5b-ac2c-bd4b0f11a37c',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '10. Are you satisfied with your employee benefits, neither satisfied nor dissatisfied with them, or dissatisfied with them? ',
            options: [
                {
                    label: 'Extremely satisfied',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'Moderately satisfied',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'Slightly satisfied',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'Neither nor satisfied dissatisfied',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Slightly dissatisfied',
                    value: false,
                },
                {
                    id: 'dfd9be2c-c8b8-4472-9eb3-c5935466dca6',
                    label: 'Moderately dissatisfied',
                    value: false,
                },
                {
                    id: '6c8ebf19-278f-4fc0-acb6-e3aada779c26',
                    label: 'Extremely dissatisfied',
                    value: false,
                },
            ],
        },
        {
            id: '39a7cf9a-eaf6-495a-897f-ba4f63c1c916',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '11. Are  you satisfied with your job, neither satisfied nor dissatisfied with it, or dissatisfied with it? ',
            options: [
                {
                    label: 'Extremely satisfied',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'Moderately satisfied',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'Slightly satisfied',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'Neither nor satisfied dissatisfied',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Slightly dissatisfied',
                    value: false,
                },
                {
                    id: 'dfd9be2c-c8b8-4472-9eb3-c5935466dca6',
                    label: 'Moderately dissatisfied',
                    value: false,
                },
                {
                    id: '6c8ebf19-278f-4fc0-acb6-e3aada779c26',
                    label: 'Extremely dissatisfied',
                    value: false,
                },
            ],
        },
        {
            id: '72f5bfa5-a5a7-4d28-8f23-bedb0e987357',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '12. How proud are you of your employer’s brand?',
            options: [
                {
                    label: 'Extremely proud',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'Very proud',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'Moderately proud',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'Slightly proud',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Not at all proud',
                    value: false,
                },
            ],
        },
        {
            id: '63160549-3feb-4d2a-9ab8-0d21cb7cd5bd',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '13. Do you like your employer, neither like or dislike them, or dislike them?',
            options: [
                {
                    label: 'A great deal',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'A lot',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'A moderate amount',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'A little',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Not at all',
                    value: false,
                },
            ],
        },
        {
            id: '850c231f-a839-460e-9347-b54e0cfe7217',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '14. How likely are you to look for a job outside the company? ',
            options: [
                {
                    label: 'Extremely likely',
                    id: '1cc40bed-41de-4678-a5f8-62719b1ea353',
                    value: false,
                },
                {
                    label: 'Very likely',
                    id: '73d7612f-e615-43c1-b59f-5633d8d0c913',
                    value: false,
                },
                {
                    label: 'Moderately likely',
                    id: '6674b420-bf7a-4c6e-a9b1-cf6c101e42c6',
                    value: false,
                },
                {
                    id: '6bccd029-2957-423d-afde-976e84fe000b',
                    label: 'Slightly likely',
                    value: false,
                },
                {
                    id: '6fb3f9cf-2360-44c7-8f19-fdc8ee358932',
                    label: 'Not at all likely',
                    value: false,
                },
            ],
        },
    ],
    workspaceId: 'FAA4358B519D0E89',
};
const prebuiltEmployeeSatisfaction = (workspaceId, request) => __awaiter(void 0, void 0, void 0, function* () {
    return [
        {
            id: 0,
            variables: {
                input: [],
                output: [
                    {
                        variableName: 'Name',
                        variableId: 'd35dec1e-0ed6-48f1-b8c5-c138bb46e2dd',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                    {
                        variableName: 'Email Address',
                        variableId: '0119417b-a8d6-4e09-be15-c36c838cf484',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                    {
                        variableName: 'Department',
                        variableId: 'c0112203-d3a1-4948-854e-9f4539974377',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                    {
                        variableName: '1. How meaningful is your work? ',
                        variableId: 'fa221c95-7115-42c3-8e25-e955de6ec269',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Extremely meaningful","checked":"false"},{"id":"083d977f-98d2-40ef-a438-78180df69ddc","text":"Very meaningful","checked":"false"},{"id":2,"text":"Moderately meaningful","checked":"false"},{"id":3,"text":"Slightly meaningful","checked":"false"},{"id":"ab376685-1bc5-4d84-ab50-0a7bbeb5e4bb","text":"Not at all meaningful","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '2. How challenging is your job?',
                        variableId: '21cc0794-caac-497a-a978-9c2f5e2cca7a',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Extremely challenging","checked":"false"},{"id":2,"text":"Very challenging","checked":"false"},{"id":3,"text":"Moderately challening","checked":"false"},{"id":"39356ce5-b0b3-46e5-b04b-18474a692a4e","text":"Slightly challenging","checked":"false"},{"id":"90f2068d-3532-48bb-9e94-7386428c9bfe","text":"Not at all challenging","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '3. In a typical week, how often do you feel stressed at work? ',
                        variableId: '060784a6-eb65-4190-b0e2-ddbc1c3ed3e5',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Extremely often","checked":"false"},{"id":2,"text":"Very often","checked":"false"},{"id":3,"text":"Moderately often","checked":"false"},{"id":"fcf60a93-e658-4714-b852-39be5fc58afa","text":"Slightly often","checked":"false"},{"id":"f7539d74-ac6d-4c80-85c4-500e6e97efd5","text":"Not at all often","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '4. How well are you paid for the work you do?',
                        variableId: '4bb936d9-1c2e-4d33-94eb-9398fb302bc5',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Extremely well","checked":"false"},{"id":2,"text":"Very well","checked":"false"},{"id":3,"text":"Moderately well","checked":"false"},{"id":"f6c29626-a6a8-4c8a-965d-44f07477bb8d","text":"Slightly well","checked":"false"},{"id":"78b0fd18-028d-4d97-af47-a1f109b2c51f","text":"Not at all well","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '5. How much do your opinions about work matter to your coworkers?',
                        variableId: 'deec6969-f452-4835-ad3d-3b1870c2e40a',
                        variableType: 'string',
                        options: '[{"id":1,"text":"A great deal","checked":"false"},{"id":2,"text":"A lot","checked":"false"},{"id":3,"text":"A moderate amount","checked":"false"},{"id":"c7de88b9-caf7-4b57-92e7-c2c65824d076","text":"A little","checked":"false"},{"id":"32d9b028-224d-4765-bd93-06e83079ee84","text":"Not at all","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '6. How realistic are the expectations of your supervisor? ',
                        variableId: '8320d454-3c77-4a83-9443-6cae6b6202ef',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Extremely realistic","checked":"false"},{"id":2,"text":"Very realistic","checked":"false"},{"id":3,"text":"Moderately realistic","checked":"false"},{"id":"2c09992d-7eaf-4a3c-ac9a-aca8ad37952d","text":"Slightly realistic","checked":"false"},{"id":"7a8f62ef-2358-4dee-aee9-5c9fe3b24d0f","text":"Not at all realistic","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '7. How often do the tasks assigned to you by your supervisor help you grow professionally? ',
                        variableId: 'c4940135-03c0-42ea-8c2f-fbf77b0bc734',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Extremely often","checked":"false"},{"id":2,"text":"Very often","checked":"false"},{"id":3,"text":"Moderately often","checked":"false"},{"id":"09906c8b-1d99-465b-ad69-5efada74530e","text":"Slightly often","checked":"false"},{"id":"628eddf5-7fed-4a18-b9cf-385139d9c223","text":"Not at all often","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '8. How many opportunities do you have to get promoted where you work?',
                        variableId: 'd820261e-5097-4222-bb22-af1e6f216a1e',
                        variableType: 'string',
                        options: '[{"id":1,"text":"A great deal","checked":"false"},{"id":2,"text":"A lot","checked":"false"},{"id":3,"text":"A moderate amount","checked":"false"},{"id":"6e421466-3cfb-45f9-978f-57154382a703","text":"A little","checked":"false"},{"id":"8c096a93-0bcc-4af7-95ff-7dacf20b9222","text":"None at all ","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '9. Are you supervised too much at work, supervised too little or supervised about the right amount?',
                        variableId: '8b30eced-1ff1-43f1-b6b4-5edaa76da25e',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Much too much","checked":"false"},{"id":2,"text":"Somewhat too much","checked":"false"},{"id":3,"text":"Slightly too much","checked":"false"},{"id":"6eb1c5bd-7449-4a8a-9069-f3cddbdf57e8","text":"About the right amount","checked":"false"},{"id":"84476b5d-d6a5-45f8-91c7-6dca3d9b2206","text":"Slightly too little","checked":"false"},{"id":"e9bc3903-23e6-4834-9fd8-77919c5f23d7","text":"Somewhat too little","checked":"false"},{"id":"9b368a0d-1ff7-4afb-9dcd-f2689133b617","text":"Much too little","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '10. Are you satisfied with your employee benefits, neither satisfied nor dissatisfied with them, or dissatisfied with them? ',
                        variableId: '850cd12a-8bec-4c5b-ac2c-bd4b0f11a37c',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Extremely satisfied","checked":"false"},{"id":2,"text":"Moderately satisfied","checked":"false"},{"id":3,"text":"Slightly satisfied","checked":"false"},{"id":"93e6a5ce-c044-451d-be80-d71271da663d","text":"Neither satisfied nor dissatisfied","checked":"false"},{"id":"dc5f5ca9-b74b-4b60-aad3-9195abeadfe7","text":"Slightly dissatisfied","checked":"false"},{"id":"a49bbae1-4ccf-48ed-844e-8e48c620b467","text":"Moderately dissatisfied","checked":"false"},{"id":"02132608-4348-46c0-ae19-f61166f9dab6","text":"Extremely dissatisfied","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '11. Are  you satisfied with your job, neither satisfied nor dissatisfied with it, or dissatisfied with it? ',
                        variableId: '39a7cf9a-eaf6-495a-897f-ba4f63c1c916',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Extremely satisfied","checked":"false"},{"id":2,"text":"Moderately satisfied","checked":"false"},{"id":3,"text":"Slightly satisfied","checked":"false"},{"id":"f445f79a-61da-4897-ad25-2cc93f4e305d","text":"Neither satisfied nor dissatisfied","checked":"false"},{"id":"88670a9f-c68c-4ba0-9443-ec6740fe9c79","text":"Slightly dissatisfied","checked":"false"},{"id":"7d611066-0386-4a7b-bae4-05fa340adc79","text":"Moderately dissatisfied","checked":"false"},{"id":"c3f416ed-9f20-41fb-8938-c6b66845182f","text":"Extremely dissatisfied","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '12. How proud are you of your employer’s brand?',
                        variableId: '72f5bfa5-a5a7-4d28-8f23-bedb0e987357',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Extremely proud","checked":"false"},{"id":2,"text":"Very proud","checked":"false"},{"id":3,"text":"Moderately proud","checked":"false"},{"id":"885e2ba6-a7c2-4099-a186-57fba4242f3a","text":"Slightly proud","checked":"false"},{"id":"61bba726-72ad-4ee8-a1bd-364e414c4032","text":"Not at all proud","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '13. Do you like your employer, neither like or dislike them, or dislike them?',
                        variableId: '63160549-3feb-4d2a-9ab8-0d21cb7cd5bd',
                        variableType: 'string',
                        options: '[{"id":1,"text":"A great deal","checked":"false"},{"id":2,"text":"A lot","checked":"false"},{"id":3,"text":"A moderate amount","checked":"false"},{"id":"16d4e3e1-459c-4d80-9e55-90b79597ad6b","text":"A little","checked":"false"},{"id":"a7be2214-c126-457f-bddc-54b5c80501fa","text":"Not at all","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '14. How likely are you to look for a job outside the company? ',
                        variableId: '850c231f-a839-460e-9347-b54e0cfe7217',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Extremely likely","checked":"false"},{"id":2,"text":"Very likely","checked":"false"},{"id":3,"text":"Moderately likely","checked":"false"},{"id":"c2520d32-f9e5-4e3b-bd43-1ef80f0d91ef","text":"Slightly likely","checked":"false"},{"id":"131ffbd9-1df7-404d-b84f-db0182ad6595","text":"Not at all likely","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                ],
            },
            type: 'start',
            next: null,
            isDirty: true,
            version: '1.0.2',
            data: {
                stepName: 'Trigger',
                triggers: [
                    {
                        id: 0,
                        type: 'form',
                        data: {
                            form: yield (0, templateUtils_1.getContentData)({
                                request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, triggerFormContent), { workspaceId })); }),
                            }),
                        },
                    },
                ],
            },
        },
    ];
});
exports.prebuiltEmployeeSatisfaction = prebuiltEmployeeSatisfaction;
//# sourceMappingURL=employeeSatisfaction.js.map